<script >
    import AtAGlance from './AtAGlance.svelte';
    import AtAGlancePrecinctsReporting from './AtAGlancePrecinctsReporting.svelte';

    /**
   * A readable Svelte store of an individual Race.
   *
   *  @type {import('../types.d').RaceFeed}
   */
    export let precincts;

        /**
   * A readable Svelte store of an individual Race.
   *
   *  @type {import('../types.d').RaceFeed}
   */
   export let gov;

           /**
   * A readable Svelte store of an individual Race.
   *
   *  @type {import('../types.d').RaceFeed}
   */
   export let ag;
   
    /**
     * @type {Map<string, import('../types.d').Crosswalk>}
     */
    export let crosswalk;

    const races = ['aag-CA-G6119-2022-06-07', 'aag-CA-A6142-2022-06-07'];  

   $:votesIn = ($gov.total_votes > 0) && ($ag.total_votes > 0);

</script>

<div class="aag-container " aria-hidden="{votesIn ? 'false' : 'true'}">
  <p class="aag-title">Key races at a glance</p>
  <p class="section-deck">Top two advance to November election</p>
  <div class="aag-races-container display-grid grid-cols-2 grid-gap-3 mb-3">
    {#each races as race}
    <div class="race-container" id="{ race }">
      {#if race == races[0] }
      <AtAGlance 
        race = {gov}
        crosswalk = {crosswalk}
      />
      {/if}
      {#if race == races[1] }
      <AtAGlance 
      race = {ag}
      crosswalk = {crosswalk}
      />
      {/if}
      </div>
    {/each}
  </div>
</div>